import { lazyLoad } from '../../utils/loadable';
export var ProfilePage = lazyLoad(function () { return import('./Profile'); }, function (module) { return module.Profile; });
export var EditProfilePage = lazyLoad(function () { return import('./EditProfile'); }, function (module) { return module.EditProfile; });
